module.exports = __webpack_public_path__ + "static/media/fundo_desintec_armadilhaDisseminadoraInseticida.fe116d98.png";